<template>
    <div class="flex justify-center pt-2 md:pt-8">
        <div class="flex flex-wrap md:w-3/4 lg:w-3/5 xl:1/2">
            <!-- Tailwind -> Application UI -> Layout -> Panels -> Card with Header and Footer -->
            <!-- https://tailwindui.com/components/application-ui/layout/panels#component-86cba6bd01f8053d3a7f0d071121c1ee -->
            <div class="w-full bg-white overflow-hidden shadow rounded-lg">
                <div class="border-b-2 border-gray-200 px-4 py-5 sm:px-6">

                    <!-- https://tailwindui.com/components/application-ui/headings/card-headings#component-db063e3ead0c9a42d8b931c920062e56-->
                    <!-- But removed the bottom border as our card handles that-->
                    <div class="bg-white px-4 py-5 sm:px-6">
                        <p class="text-lg leading-6 font-medium text-gray-900">
                            <slot name="top-header"></slot>
                        </p>
                        <p class="mt-1 text-sm leading-5 text-gray-500">
                            <slot name="top-content"></slot>
                        </p>
                    </div>
                </div>


                <div class="px-4 py-5 sm:p-6 border-b border-dotted">
                    <slot name="body-summary"></slot>
                </div>

                <div class="px-4 py-5 sm:p-6">
                    <slot name="body-action"></slot>
                </div>


                <div class="border-t-2 border-gray-200 px-4 py-4 sm:px-6">
                    <!-- https://tailwindui.com/components/application-ui/headings/card-headings#component-c8f5fb604fcc6cf6614aab0bfec6a3f2-->
                    <!-- But removed the bottom border-->
                    <div class="bg-white px-4 py-5 sm:px-6">
                        <div class="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
                            <div class="ml-4 mt-4">
                                <p class="text-lg leading-6 font-medium text-gray-900">
                                    <slot name="bottom-header"></slot>
                                </p>
                                <p class="mt-1 text-sm leading-5 text-gray-500">
                                    <slot name="bottom-content"></slot>
                                </p>
                            </div>
                            <div class="ml-4 mt-4 shrink-0">
                                <span class="inline-flex rounded-md shadow-sm">
                                  <slot name="bottom-button">
                                      <a>
                                          <button type="button"
                                                  @click="completeStep"
                                                  class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:ring-blue-200 focus:border-blue-700 active:bg-blue-700">
                                            <slot name="bottom-button-text">Complete and move on!</slot>
                                          </button>
                                      </a>
                                  </slot>
                              </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "InstallWizardCard",
        props: {
            specialRoute: String,
            shouldComplete: {
                type: Boolean,
                default: true,
            }
        },
        data() {
            return {}
        },
        methods: {
            completeStep() {
                axios.post(this.targetRoute, {'shouldComplete': this.shouldComplete}).then(function (response) {
                    window.location.href = response.data.target;
                    return true;
                })
            }
        },
        computed: {
            targetRoute: function () {
                if (this.specialRoute) {
                    return this.specialRoute;
                } else {
                    return window.location.pathname;
                }
            }
        }
    }
</script>

<style scoped>

</style>